import React from "react";
import Contact from "../../Components/Contact/Contact";

const ContactPage = () => <Contact />;

export default ContactPage;
